import { LDFlagSet, useFlags } from 'launchdarkly-react-client-sdk';

export interface ExpressableFlags extends LDFlagSet {
  signupShowLandingPage: boolean;
  signupScheduleByTimes: boolean;
}

export const useLDFlags = () => useFlags<ExpressableFlags>();

export enum LDContext {
  /** Authenticated portal client */
  PORTAL_CLIENT = 'user',
  /** Unauthenticated portal device from signup */
  SIGNUP_DEVICE = 'portal-device',

  /** Unauthenticated portal device from screener */
  SCREENER_DEVICE = 'portal-screener-device',
}
